import { render, staticRenderFns } from "./VodHistory.vue?vue&type=template&id=6448e1b3&scoped=true&"
import script from "./VodHistory.vue?vue&type=script&lang=js&"
export * from "./VodHistory.vue?vue&type=script&lang=js&"
import style0 from "./VodHistory.vue?vue&type=style&index=0&id=6448e1b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448e1b3",
  null
  
)

export default component.exports